export default "Those are kind of the two most important parts of generating images with AI\n"